/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'

const TopicNotSelectedGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting(widgetId)
  const { t } = useTranslation()

  if (!widgetSetting.selectedTopic) return <ErrorMessage>{t('topicInaccessible')}</ErrorMessage>

  return children
}

export default TopicNotSelectedGuard
